/* Shop catalog: activity filter. Product links open full product pages. */
(function () {
  var section = document.querySelector('[data-catalog]');
  if (!section) return;
  var cards = Array.prototype.slice.call(section.querySelectorAll('[data-product-card]'));

  /* Filter */
  var group = section.querySelector('[data-filter-group]');
  var count = section.querySelector('[data-filter-count]');
  if (group) {
    group.hidden = false;
    group.addEventListener('click', function (e) {
      var button = e.target.closest('button[data-filter]');
      if (!button) return;
      var value = button.getAttribute('data-filter');
      group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
      var shown = 0;
      cards.forEach(function (card) {
        var match = value === 'All' || card.getAttribute('data-category') === value;
        card.hidden = !match;
        if (match) shown += 1;
      });
      if (count) count.textContent = shown;
    });
  }

})();
